import styled from 'styled-components';
const UITourPulserLayer = styled.svg.attrs(props => ({
  // This is for preventing generating duplicate style in renderings
  style: {
    zIndex: props.zIndex
  }
})).withConfig({
  displayName: "UITourPulserLayer",
  componentId: "sc-1mwjhgr-0"
})([".hs-private.hs-private.hs-private &{height:100vh;left:0;opacity:0;overflow:hidden;pointer-events:none;position:fixed;top:0;width:100vw;}.hs-private.hs-private.hs-private &.tour-pulser--visible{opacity:1;transition:opacity 0.3s ease-out;}.hs-private.hs-private.hs-private & .tour-pulser-overlay{pointer-events:all;}"]);
export default UITourPulserLayer;